import { useEffect, useState } from 'react';

const PERSIST_KEY = 'persist';

export default function usePersist() {
    
    const [persist, setPersist] = useState<boolean>(() => {
        const storedPersist = localStorage.getItem(PERSIST_KEY);

        if (storedPersist === null) {
            return true;
        }

        try {
            return JSON.parse(storedPersist);
        } catch {
            return true;
        }
    });

    useEffect(() => {
        localStorage.setItem(PERSIST_KEY, JSON.stringify(persist));
    }, [persist]);

    return [persist, setPersist] as const;
}